import { AxiosError } from "axios";
import { UseQueryResult } from "@tanstack/react-query";

import { useGetBooleanFlagState } from "generated/api/feature-flags/feature-flags";
import { FeatureFlag } from "types/flags/FeatureFlag";

export function useFeatureFlag(
  flagKey: FeatureFlag,
): UseQueryResult<boolean, AxiosError> {
  return useGetBooleanFlagState<boolean, AxiosError>(flagKey, {
    query: {
      refetchOnWindowFocus: false,
      gcTime: Infinity,
      staleTime: 300000, // 5 minutes
    },
  });
}
